import { ComponentPropsWithRef } from "react";
import CheckBoxStyle from "./css/CheckBox.module.css";
import IcoCheckBold from "../../assets/img/IcoCheckBold";

type CheckBoxProps = ComponentPropsWithRef<"input">;


function CheckBox({ ...props }: CheckBoxProps) {
    return (
        <div className={CheckBoxStyle["check_box_wrap"]}>
            <input
                className={CheckBoxStyle["check_box"]}
                type="checkbox"
                {...props}
            />
            <IcoCheckBold />
        </div>
    )
}

export default CheckBox;